/**
 * title -> string = título para o componente PagTitle
 * subtitle -> string = subtítulo para o componente PagTitle
 * content -> string = conteúdo central do card
 * image -> string = rota/caminnho da imagem inserida
 */
 
import PageTitle from "../PageTitle/PageTitle";
import ResponsiveImage from "../ResponsiveImage/ResponsiveImage";
import './RegionServed.css'

const RegionServed = (props) => {

    const { title, subtitle, content, image } = props

    return (
        <section className="region-container">
            <div className="region-container-title">
                <PageTitle title={title} subtitle={subtitle} />
                <span>{content}</span>
            </div>
            <div className="region-container-mapa">
                <ResponsiveImage width={'770px'} height={'570px'} image={image} />
            </div>
        </section>
    )

}

export default RegionServed;